import { apiSlice } from "../../app/api/apiSlice";

export const createEnhancedConditionsEfolderApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		enhancedConditionsEFolderCreation: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/create_efolder_document/${credentials.loanGuid}/`,
				method: "PATCH",
				body: {
					document_name:
						credentials.documentName ||
						credentials.title ||
						credentials.document_name ||
						"",
					description: credentials.description,
				},
			}),
		}),
	}),
});

export const { useEnhancedConditionsEFolderCreationMutation } = createEnhancedConditionsEfolderApiSlice;
